var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showFooter
    ? _c("footer", [
        _c("div", { staticClass: "footer__container" }, [
          _c("div", { staticClass: "footer__item" }, [
            _c("h1", { staticClass: "footer__item--title" }, [
              _vm._v("Products")
            ]),
            _c("ul", [
              _vm._m(0),
              _vm._m(1),
              _vm._m(2),
              _vm._m(3),
              _vm._m(4),
              _c(
                "li",
                {
                  on: {
                    click: function($event) {
                      _vm.goToScreensaverUrl()
                    }
                  }
                },
                [_vm._v("Flixel Screensaver")]
              ),
              _vm._m(5),
              _vm._m(6)
            ])
          ]),
          _c("div", { staticClass: "footer__item" }, [
            _c("h1", { staticClass: "footer__item--title" }, [
              _vm._v("Company")
            ]),
            _c("ul", [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/company" } }, [
                    _vm._v("About Flixel")
                  ])
                ],
                1
              ),
              _vm._m(7),
              _vm._m(8),
              _vm._m(9),
              _vm._m(10)
            ])
          ]),
          _vm._m(11),
          _vm._m(12),
          _vm._m(13),
          _c("div", { staticClass: "footer__item" }, [
            _c("h1", { staticClass: "footer__item--title" }, [
              _vm._v("Resources")
            ]),
            _c("ul", [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/terms/" } }, [
                    _vm._v("Terms & Conditions")
                  ])
                ],
                1
              ),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/sales-policy/" } }, [
                    _vm._v("Sales Policy")
                  ])
                ],
                1
              ),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/privacy/" } }, [
                    _vm._v("Privacy Policy")
                  ])
                ],
                1
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/products/mac/cinemagraph-pro/" } }, [
        _vm._v("Cinemagraph Pro macOS")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/products/ios/cinemagraph-pro/" } }, [
        _vm._v("Cinemagraph Pro iOS")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/products/ios/blendeo/" } }, [
        _vm._v("Blendeo")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/products/mac/persecond/" } }, [
        _vm._v("Persecond")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: { href: "https://itunes.apple.com/app/flixel-tv/id1043381618" }
        },
        [_vm._v("Flixel TV")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/products/hosting/" } }, [
        _vm._v("Cinemagraph Hosting")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/products/pricing" } }, [_vm._v("Pricing")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/studios/" } }, [_vm._v("Flixel Studios")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "http://blog.flixel.com/contact/" } }, [
        _vm._v("Contact Flixel")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "http://blog.flixel.com/flixel-press" } }, [
        _vm._v("Press")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/lp/affiliate/" } }, [_vm._v("Affiliates")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer__item" }, [
      _c("h1", { staticClass: "footer__item--title" }, [_vm._v("Blog")]),
      _c("ul", [
        _c("li", [
          _c("a", { attrs: { href: "http://blog.flixel.com" } }, [
            _vm._v("All Categories")
          ])
        ]),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "http://blog.flixel.com/category/photography/" } },
            [_vm._v("Photography")]
          )
        ]),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "http://blog.flixel.com/category/marketing/" } },
            [_vm._v("Marketing")]
          )
        ]),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "http://blog.flixel.com/category/flixel-tips-and-tricks/"
              }
            },
            [_vm._v("Tutorials")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer__item" }, [
      _c("h1", { staticClass: "footer__item--title" }, [_vm._v("Social")]),
      _c("ul", [
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.facebook.com/flixelphotos/" } },
            [_vm._v("Facebook")]
          )
        ]),
        _c("li", [
          _c("a", { attrs: { href: "https://twitter.com/Flixel" } }, [
            _vm._v("Twitter")
          ])
        ]),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.instagram.com/flixelphotos" } },
            [_vm._v("Instagram")]
          )
        ]),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.youtube.com/channel/UC0TePK05Rsm3GnPdNyLihWA"
              }
            },
            [_vm._v("Youtube")]
          )
        ]),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.snapchat.com/add/flixelphotos" } },
            [_vm._v("Snapchat")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer__item" }, [
      _c("h1", { staticClass: "footer__item--title" }, [_vm._v("Learn")]),
      _c("ul", [
        _c("li", [
          _c("a", { attrs: { href: "/tutorials/" } }, [_vm._v("Tutorials")])
        ]),
        _c("li", [
          _c("a", { attrs: { href: "/case-studies" } }, [
            _vm._v("Case Studies")
          ])
        ]),
        _c("li", [
          _c("a", { attrs: { href: "http://support.flixel.com/" } }, [
            _vm._v("Help Center")
          ])
        ]),
        _c("li", [
          _c("a", { attrs: { href: "https://forums.flixel.com" } }, [
            _vm._v("Forums")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 